import { required, minLength, email, maxLength } from 'vuelidate/lib/validators'
import { phoneNumber } from '~/validations/validations.js'

export default {
  props: {
    isLead: {
      type: Boolean,
      default: false
    },
    product: {
      type: Number
    },
    id: {
      type: String
    },
    hash: {
      type: String
    },
    plan: {
      type: [Number, String]
    }
  },
  components: {
    HeaderBlock: () => import('~/components/commom/header/index'),
    InputBlock: () => import('~/components/commom/input-block/index'),
    ButtonBlock: () => import('~/components/commom/button-block/index'),
    ErrorBlock: () => import('~/components/commom/error-block/index')
  },
  data() {
    return {
      firstName: this.$store.state.auth.isLoggedIn
        ? this.$store.state.auth.user.firstName
        : '',
      lastName: this.$store.state.auth.isLoggedIn
        ? this.$store.state.auth.user.lastName
        : '',
      email: this.$store.state.auth.isLoggedIn
        ? this.$store.state.auth.user.email
        : '',
      phone: this.$store.state.auth.isLoggedIn
        ? this.$store.state.auth.user.phoneNumber
        : '',
      message: ''
    }
  },

  validations: {
    firstName: {
      required,
      minLength: minLength(2)
    },
    lastName: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    phone: {
      required,
      minLength: minLength(9),
      phoneNumber,
      maxLength: maxLength(9)
    }
  },

  computed: {
    isLoggedIn() {
      return this.$store.state.auth.isLoggedIn
    },

    isDiscountLead() {
      const query = this.$nuxt.$route.query

      if (!Object.prototype.hasOwnProperty.call(query, 'isDiscountLead')) {
        return false
      }

      return query.isDiscountLead
    }
  },

  methods: {
    goToGreetingPage() {
      return this.$router.push(
        this.localePath({
          name: 'simulacao-seguro-automovel-obrigado-id-hash-plan',
          params: {
            id: this.id,
            hash: this.hash,
            plan: this.plan
          }
        })
      )
    },

    handleFormSubmit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      if (this.isLead) {
        this.sendEmailToAdmin()
        return this.handleLeadUpdateOrCreation()
      }
      return this.sendEmailToAdmin()
    },

    sendEmailToAdmin() {
      if (this.message !== '') {
        return this.$axios
          .post('emails/request-contact', {
            email: this.email,
            name: `${this.firstName} ${this.lastName}`,
            phoneNumber: this.phone,
            message: this.message,
            language: this.$cookies.get('user_language')
          })
          .then((_) => {
            this.$router.push(
              this.localePath({
                name: 'contacte-nos-obrigado',
                params: {
                  id: this.id,
                  hash: this.hash,
                  plan: this.plan
                }
              })
            )
          })
      } else {
        return this.$axios
          .post('emails/request-contact', {
            email: this.email,
            name: `${this.firstName} ${this.lastName}`,
            phoneNumber: this.phone,
            message: 'Pedido de contacto efetuado apartir de kweeder.com',
            language: this.$cookies.get('user_language')
          })
          .then((_) => {
            this.$router.push(
              this.localePath({
                name: 'contacte-nos-obrigado',
                params: {
                  id: this.id,
                  hash: this.hash,
                  plan: this.plan
                }
              })
            )
          })
      }
    },

    handleLeadUpdateOrCreation() {
      if (!this.isLoggedIn) {
        return this.turnLeadHot()
      }

      if (this.isDiscountLead) {
        return this.createLead(true)
      }

      return this.createLead(false)
    },

    createLead(isDiscount) {
      this.$store
        .dispatch('leads/createLead', {
          requestID: this.id,
          productID: this.product,
          planID: parseInt(this.plan, 10),
          leadType: isDiscount ? 'D' : 'H'
        })
        .then((_) => {
          this.goToGreetingPage()
        })
    },

    turnLeadHot() {
      this.$gtm.pushEvent({
        event: this.getEventNameForProduct()
      })

      this.$store
        .dispatch('leads/turnLeadHot', {
          requestID: this.id,
          productID: this.product,
          planID: parseInt(this.plan, 10),
          hash: this.hash,
          email: this.email,
          name: `${this.firstName} ${this.lastName}`,
          phoneNumber: this.phone,
          message: this.message
        })
        .then((_) => {
          this.goToGreetingPage()
        })
    },

    getEventNameForProduct() {
      switch (this.product) {
        case 2:
          return 'car_ask_for_contact'

        case 8:
          return 'life_ask_for_contact'
      }
    }
  }
}
